// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"581":"ed4d4d41","832":"36033b10"}[chunkId] + ".chunk.css";
};